
import "../Services.css";
import DeskImage from "../../Assets/Images/CFO.jpg";
import CFOfaq from "./CFOfaq.js";

const App = () => {
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>CFO Advisory Services: Elevate Growth, Optimize Benefits!</h1>
            <p className="hero-subtitle">Strategic finance, forecasting, and compliance — tailored for scaling businesses.</p>
          </div>
          <div className="hero-media">
            <img src={DeskImage} alt="CFO Advisory" className="desk-image" />
          </div>
        </div>
      </div>
      <CFOfaq />
    </section>
  );
};

export default App;
